<div *ngIf="jobsResult && !jobsResult.totalValues">
  <ng-content></ng-content>
</div>
<div class="bmc-jobs-table__loading-container" *ngIf="isLoadingJobs">
  <bzg-loading [size]="'m'" class="bmc-jobs-table__loading">
    {{ 'GLOBAL.LOADING_DATA' | translate }}</bzg-loading>
</div>
<div class="bmc-jobs-table__container" *ngIf="jobsResult && jobsResult.totalValues != 0">
  <div  class="bmc-jobs-table">
    <div class="bz-space--stack-l bmc-jobs-table__show-hide-button">
      <bzg-button-secondary (click)="showJobsFilter()" [icon]="'icon-gear'" [size]="'s'" >
        {{'GLOBAL.SHOW_AND_HIDE_ITEMS' | translate}}
      </bzg-button-secondary>
    </div>

    <div class="bmc-jobs-table__scrollable-container">
      <table class="bz-table bz-space--stack-xl">
        <thead>
          <tr>
            <th class="bz-table__cell bz-table__cell--sortable" *ngFor="let col of columns">
              <div class="bz-table__col-title" *ngIf="col.visible">
                <span class="bz-space--inline-xs">{{ col.value | translate}}</span>
                <div class="bz-table__col-sort">
                  <bzg-icon [nameIcon]="'icon-arrow-down-table'" (click)="sortByColumn(col.key, 1)"
                    *ngIf="sortOptions.columnName === '' || (sortOptions.columnName === col.key && sortOptions.orderType === 0) || sortOptions.columnName !== col.key ">
                  </bzg-icon>
                  <bzg-icon [nameIcon]="'icon-arrow-up-table'" (click)="sortByColumn(col.key, 0)"
                    *ngIf="sortOptions.columnName === col.key && sortOptions.orderType === 1">
                  </bzg-icon>
                </div>
              </div>

            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let job of jobsResult.values">
            <td class="bz-table__cell" *ngFor="let col of columns" [ngClass]="{'bmc-jobs-table__clickable': col.type !== 'result'}" (click)="col.type !== 'result' ? showJobDetail(job) : ''">
              <div *ngIf="col.visible">
                <div class="bz-table__cell-row" *ngIf="col.type === 'link' "><a class="bz-link bmc-jobs-table__link"
                    (click)="col.action(job)">{{ job[col.key] }}</a></div>
                <div class="bz-table__cell-row bz-table__cell-row--center" *ngIf="col.type === 'text' ">
                  {{ job[col.key] }}
                </div>
                <div class="bz-table__cell-row bz-table__cell-row--center" *ngIf="col.type === 'date' ">
                  {{ job[col.key] | showDateFormat: 1}}</div>
                <div class="bz-table__cell-row bz-table__cell-row--center" *ngIf="col.type === 'boolean'">
                  <bzg-checkbox [checked]="job[col.key]" [disabled]="col.readonly"></bzg-checkbox>
                </div>
                <div *ngIf="col.type === 'result'">
                  <bzg-icon [nameIcon]="'icon-check-mark'" [color]="'success'" *ngIf="job.hasExecutionLogs && job.executionResult">
                  </bzg-icon>
                  <div class="bmc-jobs-table__warning-container" *ngIf="job.hasExecutionLogs && !job.executionResult">
                    <bzg-icon [nameIcon]="'icon-warning'" [color]="'error'" class="bz-space--inline-s">
                    </bzg-icon>
                    <a class="bz-font-size--body-small bz-link bmc-jobs-table__link"
                      (click)="openErrorModal(job.executionMessage)">{{'GLOBAL.MESSAGE' | translate}}</a>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="bz-table-pagination">
      <bzg-paginator [pageSize]="10" [totalItems]="jobsResult.totalValues"
        [pageSizeOptions]="[10, 30, 50, 100, 200, 500]" (paginationChanged)="onPaginationEvent($event)">
      </bzg-paginator>
    </div>
  </div>
</div>
<div class="bmc-jobs-table__container-empty" *ngIf="jobsResult && jobsResult.totalValues == 0">
  <h3>{{titleTranslate}}</h3>
  <h4>{{subtitleTranslate}}</h4>
</div>
